import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import MainRouter from './routes/MainRouter';
import './globals.module.scss';
import { Toaster } from 'react-hot-toast';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrandingProvider } from 'app-context/BrandingsContext';
import { ToastProvider } from 'app-context/toasterContext/ToastContext';
import { SideBarStateProvider } from 'app-context/mobile-sidebar-state/MobileSibebar';
import { UserProvider } from 'app-context/user/UserContext';
import 'slick-carousel/slick/slick.css';
import 'react-phone-number-input/style.css';
import { TourProvider } from 'app-context/tourContext/TourContext';
import { SidebarDataProvider } from 'app-context/sidebar/SidebarDataProvider';
import { AutoUpdateProvider } from 'app-context/auto-update/AutoUpdate';
import { ChatSidebarProvider } from 'app-context/Chat-sidebar-context/ChatSidebarContext';

const queryClient = new QueryClient();

const App = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <AutoUpdateProvider>
        <ChatSidebarProvider defaultOpen={true} persistKey='chat_sidebar_open'>
          <SidebarDataProvider>
            <ToastProvider>
              <BrandingProvider>
                <UserProvider>
                  <SideBarStateProvider>
                    <Toaster position='top-center' reverseOrder={false} />
                    <BrowserRouter>
                      <TourProvider>
                        <MainRouter />
                      </TourProvider>
                    </BrowserRouter>
                  </SideBarStateProvider>
                </UserProvider>
              </BrandingProvider>
            </ToastProvider>
          </SidebarDataProvider>{' '}
        </ChatSidebarProvider>
      </AutoUpdateProvider>
    </QueryClientProvider>
  );
};

export default App;
